import type { ReactNode } from 'react';
import { cn } from '@/utils/cn';

interface Props {
  className?: string;
  children: ReactNode;
}

const GlobalContainer = ({ className, children }: Props) => {
  return (
    <div className={cn('global-container', className)}>
      {children}
    </div>
  );
};

export default GlobalContainer;
